var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrabhuTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2954_4470",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 51,
    width: 272,
    height: 239
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.531 51H468.996V289.91H197.531V51Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2954_4470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.547 219.035H355.112V282.019L468.203 166.509L355.112 51V113.984H199.547V219.035Z",
    fill: "#231942"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2954_4470",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 216,
    width: 274,
    height: 233
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 216.888H304.917V449H31V216.888Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2954_4470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.689 386.061H144.091V448.997L31 333.488L144.091 217.931V280.914H299.689V386.061Z",
    fill: "#231942"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrabhuTransfer);
export default __webpack_public_path__ + "static/media/prabhu_transfer.3e4cffc6cf685f7bc7a0ed7b07b3c5a4.svg";
export { ForwardRef as ReactComponent };